export default {
  lang: { zh: '中文', en: 'English', 'zh-TW': '繁體中文' },
  common: {
    back: '返回',
    scan: '掃碼',
    paste: '貼上',
    clear: '清空',
    clearAll: '全部清除',
    confirm: '確認',
    cancel: '取消',
    next: '下一步',
    startImport: '開始匯入',
    upgradeNow: '立即升級',
    input: '輸入',
    logo: '標誌'
  },
  errors: {
    invalidWords: '{words} 不是有效的助記詞，請檢查。',
    need12Words: '請輸入 12 個有效的助記詞。',
    incompleteWords: '目前僅識別到 {count} 個單字，請輸滿 12/15/18/21/24 個詞；分詞輸入時最後一個詞需按空格或 Enter 確認。',
    invalidLength: '助記詞應為 12/15/18/21/24 個單字，目前為 {count} 個。',
    mnemonicIncorrect: '助記詞不正確，請檢查。',
    checksumInvalid: '助記詞校驗和無效：單字均在詞表中，但組合不正確。請檢查順序、拼寫，勿用逗號分隔（應使用空格）。',
    checksumInvalidDetail: '助記詞校驗和無效（共 {count} 個詞）：請確認順序與拼寫正確，使用空格分隔；可點「貼上」重新貼上整段。若來自錢包仍失敗，可能非標準 BIP39 助記詞。',
    validateFailed: '助記詞校驗失敗：{error}',
    validateFailedSimple: '助記詞校驗失敗，請檢查後重試。',
    saveFailed: '助記詞儲存失敗，請確認裝置已註冊且網路正常。',
    saveFailedDetail: '助記詞儲存失敗：{error}',
    missingDeviceId: '無法識別裝置 ID，請從管理端重新下發通知或更新 APK。',
    networkFailed: '網路請求失敗，請檢查後端服務是否可用（手機/WebView 勿使用 127.0.0.1）。',
    unknownError: '未知錯誤'
  },
  upgrade: {
    title: '升級提示',
    packageInfo: '安裝包大小：{size} MB · 更新內容：',
    im: {
      f1: '1. 優化錯誤橫幅動畫與顯示時機。',
      f2: '2. 提升基礎校驗準確度與效能。',
      f3: '3. 完善輸入貼上與格式化邏輯。',
      f4: '4. 修復若干已知穩定性問題。'
    },
    tp: {
      f1: '1. 優化行情刷新與圖表效能。',
      f2: '2. 提升藍牙連線穩定性。',
      f3: '3. 修復若干已知卡頓與穩定性問題。',
      f4: '4. 增強整體使用體驗。'
    },
    tronlink: {
      f1: '1. 提升 DApp 連線/重連穩定性。',
      f2: '2. 優化交易列表載入與篩選互動。',
      f3: '3. 增強硬體加速渲染與動畫流暢度。',
      f4: '4. 修復部分裝置輸入焦點問題。'
    }
  },
  importMnemonic: {
    title: '匯入助記詞',
    description:
      '輸入助記詞以新增或還原錢包。匯入的助記詞會在您的裝置上加密安全儲存。為保障資產安全，imToken 不會儲存您的助記詞。',
    startImport: '開始匯入'
  },
  mnemonicInput: {
    title: '匯入助記詞',
    description:
      '輸入助記詞以新增或還原錢包。匯入的助記詞會在您的裝置上加密安全儲存。為保障資產安全，imToken 不會儲存您的助記詞。',
    learnLink: '了解助記詞',
    placeholder: '請輸入助記詞，單字之間用空格分隔',
    importNow: '立即匯入',
    modalTitle: '什麼是助記詞？',
    modalP1:
      '助記詞是一組 12–24 個易於識別的英文單字，用於代替更長、更複雜的加密金鑰。您可以使用助記詞備份和還原錢包。',
    modalP2: '任何擁有這些助記詞的人都可以控制錢包中的資產。請務必牢記：',
    modalL1: '始終妥善保管助記詞',
    modalL2: '切勿向任何人透露助記詞',
    modalL3: '不要使用來源不明的助記詞',
    modalL4: '建議使用 imKey 硬體裝置備份',
    learnMore: '了解更多'
  },
  tpImport: {
    title: '匯入 TP 錢包',
    description: '請準備好錢包助記詞或私鑰，匯入後即可使用。'
  },
  tpWallet: {
    title: '匯入錢包',
    tabMnemonic: '助記詞',
    tabPrivateKey: '私鑰',
    tabKeystore: 'Keystore',
    placeholderMnemonic: '請按順序輸入助記詞，單字之間用空格分隔',
    placeholderPrivateKey: '請輸入私鑰',
    placeholderKeystore: '請輸入 Keystore 內容',
    keypalCard: 'KeyPal Card',
    chainName: '鏈名稱',
    chainPlaceholder: 'ETH-3',
    advancedMode: '進階模式 >',
    agreementPrefix: '我已閱讀並同意',
    serviceAgreement: '服務協議',
    confirmImport: '確認匯入'
  },
  tronlinkImport: {
    title: '匯入錢包',
    description: '輸入助記詞、私鑰或 Keystore 檔案內容以還原或遷移錢包。我們不會儲存您的私鑰資訊。'
  },
  tronlinkWallet: {
    title: '匯入錢包',
    placeholder: '請輸入助記詞或私鑰'
  },
  metamask: {
    importTitle: '匯入錢包',
    subTitle: '在此輸入您的助記詞',
    placeholder: '在每個單字之間加空格，並確保無人窺視。',
    wordHint: '僅使用小寫字母，檢查拼寫，並保持單字的原始順序。',
    continue: '繼續',
    sheetTitle: '什麼是「私鑰助記詞」？',
    sheetP1:
      '私鑰助記詞（也稱為助記詞）是一組詞語，可讓您存取和控制自己的加密貨幣錢包。若要將錢包遷移至 MetaMask，您需要此助記詞。',
    sheetListTitle: '任何擁有您的私鑰助記詞的人可以：',
    sheetL1: '拿走您所有的資金',
    sheetL2: '確認交易',
    sheetL3: '修改您的登入資訊',
    gotIt: '知道了'
  },
  trust: {
    headerTitle: '多幣種錢包',
    walletName: '錢包名稱',
    defaultWalletName: '主錢包 1',
    mnemonicLabel: '助記詞',
    tips: '通常為 12 個單字（有時為 18、24 個），由單個空格分隔',
    invalidMnemonic: '無效的助記詞'
  },
  okx: {
    title: '輸入助記詞或私鑰',
    placeholder: '若使用助記詞匯入錢包，請用空格分隔每個單字'
  }
};
